<template>
  <svg class="stroke-current w-8 h-8 mr-1 md:mr-3" viewBox="0 0 37.84 40" xmlns="http://www.w3.org/2000/svg"><g fill="none" stroke-miterlimit="10"><path d="m0 22.25h17.05l2-1v-.86a6.17 6.17 0 0 0 -6.17-6.17h-12.88"/><path d="m19.07 21.3a4.78 4.78 0 0 1 3.54 4.59v5.9a2.92 2.92 0 0 1 -2.88 2.93h-19.73"/><path d="m0 32.42h19.47a3.15 3.15 0 0 0 3.14-3.14v-2.39"/><path d="m15.46 34.72h3.61v3.87a.91.91 0 0 1 -.91.91h-1.79a.91.91 0 0 1 -.91-.91z"/><circle cx="17.26" cy="27.22" r="1.81"/><path d="m0 25.56h11.3v3.14h-11.3"/><path d="m18.87 18.89h3a1.74 1.74 0 0 1 1.75 1.73v.77a.87.87 0 0 1 -.86.88h-1.52"/><circle cx="30.48" cy="7.36" r="6.86"/><path d="m30.48 36.54v-22.32"/><path d="m30 36.54h1a1.79 1.79 0 0 1 1.79 1.79v1.17h-4.62v-1.17a1.79 1.79 0 0 1 1.83-1.79z"/><path d="m28.53 11.4v-6.78h3.06a1.2 1.2 0 0 1 1.2 1.2v1a1.2 1.2 0 0 1 -1.2 1.18h-3.06"/></g></svg>
</template>

<script>
export default {

};
</script>

<style>

</style>
